module.exports = __webpack_public_path__ + "static/img/login-icon-google.3acad7ba.png";